// ANGULAR
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
// SERVICES
import { AlertService } from '@services/alert.service';
import { GlobalService } from '@services/global.service';
import { SecretosService } from '@api-requests-services/secretos.service';
// MODELS
import { Secret } from '@models/secretos.model';

export enum Views {
  Home = 'home',
  Secrets = 'secrets',
  SecretDetails = 'secretDetails',
  EditingSecret = 'editingSecret',
  CreatingSecret = 'creatingSecret',
}

@Component({
  selector: 'app-secretos',
  templateUrl: './secretos.component.html',
  styleUrl: './secretos.component.css',
  imports: [
    FormsModule,
    CommonModule
  ]
})
export class SecretosComponent implements OnInit {
  allSecrets: Secret[];
  secrets: Secret[];
  newSecret: Secret;
  secretSearched: Secret | null;
  secretSelected: Secret;
  secretNameToSearch: string;
  secretToSearch: string;  // Control de contenido html
  views = Views;
  currentView: string = Views.Home;
  secretNotFound: boolean = false;

  constructor(
    private alertService: AlertService,
    public globalService: GlobalService,
    private secretosService: SecretosService,
    private title: Title
  ) {
    this.title.setTitle('Oráculo - Secretos');
  }

  ngOnInit(): void { }

  selectView(view: string, secretSelected?: Secret): void {
    if (secretSelected) { this.secretSelected = secretSelected; }
    this.currentView = view;

    switch (this.currentView) {
      case Views.Home:
        this.secretSearched = null;
        this.secretNameToSearch = '';
        this.secretToSearch = '';
        break;
      case Views.Secrets:
        this.getSecrets();
        break;
      case Views.SecretDetails:
        this.secretToSearch = '';
        this.newSecret = { ...this.secretSelected };
        break;
      case Views.EditingSecret:
        break;
      case Views.CreatingSecret:
        this.newSecret = { nombre: '', valor: '' };
        break;
    }
  }

  getSecrets(): void {
    this.secretosService.getSecretos().subscribe(
      (secrets) => {
        if (secrets) {
          // console.log('Secretos: ', secrets);
          this.allSecrets = secrets.map(secret => ({ nombre: secret.nombre, valor: secret.valor }));
          this.secrets = this.allSecrets;
        }
      },
      error => {
        if (error.error === this.globalService.editModeDisabledMsg) {
          this.alertService.swalEditingNotEnabled();
        } else {
          this.alertService.swalError(error.error);
          console.error('Error getting Secrets:', error);
        }
      }
    );
  }

  createSecret(): void {
    if (this.newSecret) {
      this.secretosService.postCreateSecreto(this.newSecret).subscribe(
        () => {
          this.secretSelected = this.newSecret;
          this.selectView(Views.SecretDetails);
          this.alertService.showAutoCloseMessage(`¡Secreto creado!`, ``, "success", 1200);
        },
        error => {
          if (error.error === this.globalService.editModeDisabledMsg) {
            this.alertService.swalEditingNotEnabled();
          } else {
            this.alertService.swalError(error.error);
            console.error('Error creating Secret:', error);
          }
        }
      );
    }
  }

  getSecret(): void {
    if (this.secretNameToSearch) {
      this.secretosService.getSecreto(this.secretNameToSearch).subscribe(
        (secret) => {
          if (secret) {
            // console.log('Secreto: ', secret);
            this.secretNotFound = false;
            this.secretSearched = secret;
          }
        },
        error => {
          if (error.error === this.globalService.editModeDisabledMsg) {
            this.alertService.swalEditingNotEnabled();
          } else {
            if (error.status === 404) {
              this.secretNotFound = true;
            } else {
              this.secretNotFound = false;
              this.alertService.swalError(error.error);
            }
            console.error('Error getting Secret:', error);
          }
        }
      );
    }
  }

  editSecret(): void {
    if (this.newSecret) {
      this.secretosService.putEditSecreto(this.secretSelected.nombre, this.newSecret).subscribe(
        () => {
          this.selectView(Views.Secrets);
          this.alertService.showAutoCloseMessage(`¡Secreto "${this.secretSelected.nombre}" editado!`, ``, "success", 1200);
        },
        error => {
          if (error.error === this.globalService.editModeDisabledMsg) {
            this.alertService.swalEditingNotEnabled();
          } else {
            this.alertService.swalError(error.error);
            console.error('Error editing Secret:', error);
          }
        }
      );
    }
  }

  deleteSecret(): void {
    this.alertService.showConfirmAlert(
      `Eliminar Secreto`,
      `¿Seguro que quieres eliminar el Secreto con nombre "${this.secretSelected.nombre}"?`
    ).then((result) => {
      if (result.isConfirmed && this.secretSelected) {
        this.secretosService.deleteSecreto(this.secretSelected.nombre).subscribe(
          () => {
            this.selectView(Views.Secrets);
            this.alertService.showAutoCloseMessage(`¡Secreto eliminado!`, ``, "success", 1200);
          },
          error => {
            if (error.error === this.globalService.editModeDisabledMsg) {
              this.alertService.swalEditingNotEnabled();
            } else {
              this.alertService.swalError(error.error);
              console.error('Error deleting Secret:', error);
            }
          }
        );
      }
    });
  }

  onSearchChange(): void {
    this.secrets = this.allSecrets.filter(secret => secret.nombre.toLowerCase().includes(this.secretToSearch.toLowerCase()));

    if (this.secretToSearch === undefined || this.secretToSearch === '' || this.secretToSearch === ' ') {
      this.secrets = this.allSecrets;
    }
  }
}